var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.6515,
    stroke: "#0080B1",
    strokeWidth: 0.69697
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.386 12.5454L19.0225 12.5454C13.7952 12.5454 11.7043 14.6363 11.7043 19.8636L11.7043 26.1363C11.7043 31.3636 13.7952 33.4545 19.0225 33.4545H25.2952C28.557 33.4545 30.6061 32.639 31.6725 30.7467C32.1104 29.9697 32.6133 28.2272 32.6133 25.7878",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9654 16.0045L32.7267 18.8345M34.207 14.5462C34.5839 14.936 34.7926 15.4582 34.7881 16.0004C34.7836 16.5425 34.5663 17.0612 34.183 17.4447L24.31 27.3177L20.0684 28.7315L21.4822 24.4899L31.3609 14.5279C31.7082 14.1779 32.1729 13.9692 32.6652 13.942C33.1575 13.9148 33.6423 14.0712 34.026 14.3808L34.207 14.5462Z",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1895 18.1196H22.8561",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1895 22.3044H19.3713",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNotes);
export default __webpack_public_path__ + "static/media/icon-circle-notes.d2ac3233038b521bb1b437d6dee12819.svg";
export { ForwardRef as ReactComponent };